import React from "react";
import Pipeline from "./components/pipeline/Pipeline";

export default (props) => <Pipeline {...props} />

